import styled, { keyframes } from "styled-components";

import { colorsPalettes, elevation, rgba } from "@similarweb/styles";

const PREVIEW_TRANSITION = "0.3s ease";

export const StyledFloatingIconPreviewBadge = styled.div<{ $isShown: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 50%;
    width: 26px;
    height: 26px;
    border-radius: 8px 0 0 8px;
    background: ${colorsPalettes.carbon[500]};
    box-shadow: ${elevation.Z1};
    transform: ${({ $isShown }) => ($isShown ? "translate(0%, -50%)" : "translate(100%, -50%)")};
    transition: transform ${PREVIEW_TRANSITION};
`;

const logoCirclePulse = keyframes`
    0%, 100% {
        box-shadow: 0 0 0 2px ${rgba(colorsPalettes.orange[400], 0.35)};
    }
    50% {
        box-shadow: 0 0 0 5px ${rgba(colorsPalettes.orange[400], 0.08)};
    }
`;

export const StyledFloatingIconPreviewLogoWrapper = styled.div<{ $isAnimated: boolean }>`
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-left: 6px;
    border-radius: 4px;
    background: ${colorsPalettes.carbon[0]};
    flex-shrink: 0;
    transition:
        background 0.25s,
        box-shadow 0.25s;

    animation: ${({ $isAnimated }) => ($isAnimated ? logoCirclePulse : "none")};
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
`;
